
// The device's IANA timezone, e.g. "Asia/Kolkata". Null if the browser can't tell.
export const getBrowserTimezone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch {
        return null;
    }
};

// Whether the zone name is one this browser can actually format with.
export const isValidTimezone = (tz) => {
    if (!tz) return false;
    try {
        Intl.DateTimeFormat(undefined, {timeZone: tz});
        return true;
    } catch {
        return false;
    }
};

const FALLBACK_ZONES = [
    'UTC', 'Asia/Kolkata', 'Asia/Dubai', 'Asia/Riyadh', 'Asia/Singapore',
    'Asia/Tokyo', 'Australia/Sydney', 'Europe/London', 'Europe/Paris',
    'America/New_York', 'America/Chicago', 'America/Los_Angeles',
];

/** Sorted list of IANA zones for a picker. `extra` makes sure the saved value is always present. */
export const getTimezoneOptions = (extra = []) => {
    let zones;
    try {
        zones = Intl.supportedValuesOf('timeZone');
    } catch {
        zones = FALLBACK_ZONES;
    }
    const set = new Set(zones);
    set.add('UTC');
    extra.filter(Boolean).forEach((z) => set.add(z));
    return [...set].sort();
};

/** "UTC+05:30" for a zone right now, or '' if the browser can't format it. */
export const getTimezoneOffsetLabel = (tz, date = new Date()) => {
    if (!tz) return '';
    try {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            timeZoneName: 'longOffset',
        }).formatToParts(date);
        const raw = parts.find((p) => p.type === 'timeZoneName')?.value || '';
        return raw === 'GMT' ? 'UTC+00:00' : raw.replace('GMT', 'UTC');
    } catch {
        return '';
    }
};

/** "Asia/Dubai (UTC+04:00)" */
export const formatTimezoneLabel = (tz) => {
    if (!tz) return '';
    const name = tz.replace(/_/g, ' ');
    const offset = getTimezoneOffsetLabel(tz);
    return offset ? `${name} (${offset})` : name;
};



